import Vue from 'vue';
import VueRouter from 'vue-router';
import Login from '@/login/components/login/login.vue';
import { loginTitles } from '@/common/constants/title_pages';

Vue.use(VueRouter);

const loginRoutes = [
    {
        path: '/',
        component: Login,
    },
    {
        path: '*',
        component: Vue.extend({
            created: function () {
                location.href = '/';
            }
        })
    }
];
const router = new VueRouter({
    mode: 'history',
    routes: loginRoutes
});
router.beforeEach((to, from, next) => {
    document.title = loginTitles[to.name || 'default'];
    next();
});
export default router;


// WEBPACK FOOTER //
// ./login/router/login-router.ts